module.exports = __webpack_public_path__ + "img/rdai-old.99fa9093.svg";